'use client'
var version = "3.9.7";
var dependencies = {
	"@dynamic-labs/sdk-api-core": "0.0.570",
	"@dynamic-labs/utils": "3.9.7",
	"@dynamic-labs/logger": "3.9.7",
	"@dynamic-labs/types": "3.9.7",
	eventemitter3: "5.0.1",
	"@solana/web3.js": "1.92.1",
	"@turnkey/http": "2.12.2",
	"@turnkey/iframe-stamper": "2.0.0",
	"@turnkey/solana": "0.3.9",
	"@turnkey/webauthn-stamper": "0.5.0"
};

export { dependencies, version };
